/* Approved Canada collection routing; collection records remain unchanged. */
(function () {
  'use strict';
  var liveTheme = 141351092320;
  if (!window.Shopify || Number(window.Shopify.theme && window.Shopify.theme.id) !== liveTheme ||
      window.Shopify.designMode || window.Shopify.visualPreviewMode) return;

  var views = {
    'connect-bikes': 'ca-bikes',
    'stair-climbers': 'ca-stairs',
    'echelon-ellipticals': 'ca-ellipticals',
    'rowers': 'ca-rowers',
    'strength': 'ca-strength',
    'recovery': 'ca-recovery',
    'accessories': 'ca-gear'
  };

  function collectionURL(href) {
    var url;
    try { url = new URL(href, window.location.href); } catch (error) { return null; }
    if (url.origin !== window.location.origin) return null;
    var match = url.pathname.match(/^\/collections\/([^/]+)\/?$/);
    if (!match || !Object.prototype.hasOwnProperty.call(views, match[1])) return null;
    if (url.searchParams.get('view')) return null;
    url.searchParams.set('view', views[match[1]]);
    // Live links must not select a preview theme.
    url.searchParams.delete('preview_theme_id');
    return url.href;
  }

  var destination = collectionURL(window.location.href);
  if (destination) {
    window.location.replace(destination);
    return;
  }

  function decorateLink(link) {
    var destination = collectionURL(link.getAttribute('href'));
    if (destination) link.setAttribute('href', destination);
  }

  function decorateTree(root) {
    if (root.matches && root.matches('a[href]')) decorateLink(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(decorateLink);
  }

  function initialize() {
    decorateTree(document);
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (link) decorateLink(link);
    }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) decorateTree(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
